<template>
  <popConfirmButton
    :ok-text="$t('que-ren')"
    :cancel-text="$t('qu-xiao')"
    type="primary"
    class="card-btn-withdraw"
    @confirm="confirm"
  >
    <template #title>
      {{
        $t(
          'che-hui-shen-qing-hou-jiang-wu-fa-hui-fu-ru-guo-xu-yao-fa-bu-cheng-pian-jiang-xu-yao-zhong-xin-fa-qi-shen-qing-jin-hang-shen-he-shi-fou-que-ren-che-hui',
        )
      }}
    </template>
    <template #default>
      {{ $t('che-hui-fa-bu-shen-qing') }}
    </template>
  </popConfirmButton>
</template>

<script lang="ts" setup>
import popConfirmButton from './pop-confirm-button.vue';
const ctx: any = inject('personal-page-ctx');
const cardItem = inject('card-item');

const confirm = () => {
  ctx.actionWithDraw(cardItem);
};
</script>

<style lang="scss">
.card-btn-withdraw {
  flex: 1;
  border-radius: 6px;
}
</style>
